export default __webpack_public_path__ + "static/media/Support QR.a3a2d3a9.png";